import * as React from "react";
import Header from "./Header";
import HeroList, { HeroListItem } from "./HeroList";
import TextInsertion from "./TextInsertion";
import { makeStyles } from "@fluentui/react-components";
import { Ribbon24Regular, LockOpen24Regular, DesignIdeas24Regular } from "@fluentui/react-icons";
import {
  insertText,
  
  highlightInvalidOccurrence,
  replaceInvalidOccurrence,
} from "../taskpane";
import { useApi } from "../../api/useApi";
import { AuthGateClient, AuthMicrosoftNoTenantRequest, AuthResponse } from "../../api/GateApiServer";

interface AppProps {
  title: string;
}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC<AppProps> = (props: AppProps) => {
  const styles = useStyles();
  const [token, setToken] = React.useState<string | null>(null);
  const [authed, setAuthed] = React.useState<boolean>(false);
  const { unauthorizedGateApi } = useApi(AuthGateClient);
  const [userData, setUserData] = React.useState<AuthResponse | null>(null);
  // The list items are static and won't change at runtime,
  // so this should be an ordinary const, not a part of state.
  const listItems: HeroListItem[] = [
    {
      icon: <Ribbon24Regular />,
      primaryText: "Achieve more with Office integration",
    },
    {
      icon: <LockOpen24Regular />,
      primaryText: "Unlock features and functionality",
    },
    {
      icon: <DesignIdeas24Regular />,
      primaryText: "Create and visualize like a pro",
    },
  ];
  React.useEffect(() => {
    OfficeRuntime.auth
      .getAccessToken({ allowSignInPrompt: true })
      .then(async (bootstrapToken) => {
        setToken(bootstrapToken);
        unauthorizedGateApi.authMicrosoftNoTenant(new AuthMicrosoftNoTenantRequest({
          token: bootstrapToken
        })).then(r => {
          if (r.email) {
            setUserData(r);
            setToken(`Authenticated as ${r.email}`);
            setAuthed(true);
            localStorage.setItem("bearer", r.token);
          }
        })

      })
      .catch((error) => {

        setToken(`Error obtaining token: ${error.message}`);
        console.log(`Error obtaining token: ${error.message}`);
      }
      );
  }, []);
  return (
    <div className={styles.root}>
      {/* {(token === null || token === "") ? 'nefunguje' : token} */}
      <Header userData={userData} logo="assets/logo-filled.png" title={props.title} message={"Standalyzer"} />
      {/* <HeroList message="Discover what this add-in can do for you today!" items={listItems} /> */}
      {authed && <TextInsertion
        insertText={insertText}
        // validateDocument={validateDocument}
        highlightInvalidOccurrence={highlightInvalidOccurrence}
        replaceInvalidOccurrence={replaceInvalidOccurrence}
      />}
    </div>
  );
};

export default App;
